module.exports = __webpack_public_path__ + "img/1567446706.b0404e8a.jpg";